import React from 'react';
import { Link } from 'react-router';

import Button from '~/components/button';
import { categoryPageRoute, shedArticleRoute } from '~/routes';

import styles from '~/components/seed/seed-finder.module.scss';

const NoResults = ({ grassSeasonContent, grassSpeciesContent }) => (
  <section className={styles.noResultsPage}>
    <h2>
      We don’t recommend seed <br />
      for your yard
    </h2>

    <div className={styles.yourLawn}>
      <p>Your lawn at a glance</p>
      <div className={styles.lawnBadgeContainer}>
        <div className={styles.badge}>
          <img src={grassSeasonContent?.icon} alt={grassSeasonContent?.alt} />
          {grassSeasonContent?.text}
        </div>
        <div className={styles.badge}>
          <img src={grassSpeciesContent?.icon} alt={grassSpeciesContent?.alt} />
          {grassSpeciesContent?.text}
        </div>
      </div>
    </div>

    <div className={styles.fertilizersBlock}>
      <img
        alt="3 fertilizer pouches"
        sizes="(max-width: 768px) 327px, 600px"
        srcSet="/images/no-results.png 375W, /images/no-results@2x.png"
      />
      <h3>But our fertilizers would be a great fit! Here’s why:</h3>
      <ul className={styles.reasonsList}>
        <li>
          Helps your grass spread after planting via{' '}
          <Link
            to={shedArticleRoute({
              category: 'lawn',
              slug: 'warm-season-grass-propagation',
            })}
            target="_blank"
            rel="noopener noreferrer"
          >
            sprigs, sod, or plugs
          </Link>
        </li>
        <li>Precision formulas made for your southern climate</li>
        <li>Includes 1:1 guidance for maintaining a dense lawn</li>
      </ul>
      <Button
        className={styles.shopButton}
        to={categoryPageRoute('lawn-care', 'fertilizer-nutrients')}
      >
        Shop fertilizer
      </Button>
    </div>
  </section>
);

export default NoResults;
